<template>
  <div>


    <static-loading-indicator-icon/>

    <form class="mt-3" @submit.prevent="confirmCardSetup">
      <div class="card shadow-sm bg-light" v-show="!$store.getters.isExecutingRequest">
        <div class="card-body">
          <h4 class="card-title">{{ $t('pages.subscription.start.payment_method.title') }}</h4>

          <div class="form-group">
            <label for="card-holder">{{ $t('pages.subscription.start.payment_method.card_holder') }}</label>
            <input id="card-holder" class="form-control" type="text" v-model="cardHolder"
                   placeholder="John Doe">
          </div>


          <div class="form-group">
            <label for="card-number">{{
                $t('pages.subscription.start.payment_method.credit_card_number')
              }}</label>
            <span id="card-number" ref="card" class="form-control stripe-element-container"></span>
          </div>

          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="card-cvc">{{
                    $t('pages.subscription.start.payment_method.cvc_number')
                  }}</label>
                <span id="card-cvc" class="form-control stripe-element-container"></span>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="card-exp">{{
                    $t('pages.subscription.start.payment_method.expiration_date')
                  }}</label>
                <span id="card-exp" class="form-control stripe-element-container"></span>
              </div>
            </div>
          </div>



          <button class="btn btn-gradient-primary" v-if="intent !== null"
                  :disabled="$store.getters.isExecutingRequest"
                  :class="{disabled: subscribeButtonDisabled}">
            {{ $t('pages.subscription.error.update') }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import SubscriptionStartRepository from "../../../repositories/Subscription/SubscriptionStartRepository";
import StaticLoadingIndicatorIcon from "../../Includes/StaticLoadingIndicatorIcon";
import AuthRepository from "../../../repositories/Auth/AuthRepository";
import store from "../../../store/store";
import SubscriptionRepository from "../../../repositories/Subscription/SubscriptionRepository";
import SubscriptionPricingRepository from "../../../repositories/Subscription/SubscriptionPricingRepository";

let stripe = Stripe(process.env.MIX_STRIPE_KEY),
    elements = stripe.elements(),
    card = undefined;

let style = {
  base: {
    color: '#32325d',
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: 'antialiased',
    fontSize: '16px',
    '::placeholder': {
      color: '#aab7c4'
    }
  },
  invalid: {
    color: '#fa755a',
    iconColor: '#fa755a'
  }
};

export default {
  name: "AttachNewCardToUser",
  components: {StaticLoadingIndicatorIcon},
  data: () => ({
    intent: null,
    cardHolder: '',
    card: null,
    cvc: null,
    exp: null,

    confirmCardSetupPressed: false,
  }),
  mounted() {
    card = elements.create('cardNumber', {
      'placeholder': this.$t('pages.subscription.start.payment_method.credit_card_number'),
      'style': style
    });
    card.mount(this.$refs.card);

    // CVC
    this.cvc = elements.create('cardCvc', {
      'placeholder': '123',
      'style': style
    });
    this.cvc.mount('#card-cvc');

    // Card expiry
    this.exp = elements.create('cardExpiry', {
      'placeholder': 'MM/YY',
      'style': style
    });
    this.exp.mount('#card-exp');

    this.createSetupIntent();
  },
  beforeDestroy() {
    card.destroy(this.$refs.card);
    this.cvc.destroy('#card-cvc');
    this.exp.destroy('#card-exp');
  },
  computed: {
    subscribeButtonDisabled() {
      return this.$store.getters.isExecutingRequest || this.confirmCardSetupPressed;
    },

  },
  methods: {
    createSetupIntent() {
      SubscriptionStartRepository
          .createSetupIntent()
          .then((res) => {
            this.intent = res.data.intent;
          });
    },
    async confirmCardSetup() {
      if (this.confirmCardSetupPressed === true) {
        return false;
      }

      this.confirmCardSetupPressed = true;

      if (this.intent === null) {
        this.confirmCardSetupPressed = false;
        return false;
      }

      this.$store.commit('addRequestToLoadingStack', 'local');
      const {setupIntent, error} = await stripe.confirmCardSetup(
          this.intent.client_secret, {
            payment_method: {
              card: card,
              billing_details: {name: this.cardHolder}
            }
          }
      );

      if (error) {
        this.$store.commit('removeRequestFromLoadingStack', 'local');

        this.$snotify.error(error.message);
        this.createSetupIntent();
      } else {
        this.$store.commit('removeRequestFromLoadingStack', 'local');

        await SubscriptionStartRepository
            .updateCard(setupIntent.payment_method)
            .then((res) => {
              AuthRepository
                  .fetchAuthDetails()
                  .then(() => {
                    this.$router.push({name: 'subscription'});
                  });
            })
            .catch((error) => {
              if (error.response.status === 409) {
                console.log("409 reached")
                console.log(error.response.data.incomplete_payment_handling_url);
                if (typeof error.response.data.incomplete_payment_handling_url !== 'undefined') {
                  console.log("Url undefined")
                  window.location.replace(error.response.data.incomplete_payment_handling_url);
                }
              }
              this.createSetupIntent()
            });
      }
      this.confirmCardSetupPressed = false;
    }
  }
}
</script>

<style scoped>

</style>
